import { render, staticRenderFns } from "./agentBillReport.vue?vue&type=template&id=13faafa2&"
import script from "./agentBillReport.vue?vue&type=script&lang=js&"
export * from "./agentBillReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports